import { render, staticRenderFns } from "./ColorMarker.vue?vue&type=template&id=320ebe7b&"
import script from "./ColorMarker.vue?vue&type=script&lang=js&"
export * from "./ColorMarker.vue?vue&type=script&lang=js&"
import style0 from "./ColorMarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports